<template>
  <div class="modal-wrapper">
    <button class="modal-close button button--filter" @click="closeModal">
      <i class="fas fa-times"></i>
    </button>

    <div class="modal-container modal-container--transparent modal-container--large">
      <div>
        <p class="title title--1 title--white">
          {{ $t('help.title') }}
        </p>

        <p>
          {{ $t('help.subtitle') }}
        </p>
      </div>

      <div class="modal-body">
        <div class="modal-body__section">
          <span class="title title--3 title--white">{{ $t('help.general') }}</span>
          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <i class="fas fa-angle-left"></i>
            </div>
            <div class="modal-body__section__line__icon">
              <i class="fas fa-angle-right"></i>
            </div>

            <span>{{ $t('help.navigate') }}</span>
          </div>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <i class="fas fa-angle-up"></i>
            </div>
            <div class="modal-body__section__line__icon">
              <i class="fas fa-angle-down"></i>
            </div>

            <span>{{ $t('help.navigate-vertical') }}</span>
          </div>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <span>Esc</span>
            </div>
            <span>{{ $t('help.leave_full') }}</span>
          </div>
        </div>

        <div class="modal-body__section">
          <span class="title title--3 title--white">{{ $t('help.selected') }}</span>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <span>Ctrl</span>
            </div>
            <div
              class="modal-body__section__line__icon modal-body__section__line__icon--add"
            >
              <span>+</span>
            </div>
            <div class="modal-body__section__line__icon">
              <span>i</span>
            </div>
            <span>{{ $t('estimation.unusable_photo') }}</span>
          </div>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <span>Ctrl</span>
            </div>
            <div
              class="modal-body__section__line__icon modal-body__section__line__icon--add"
            >
              <span>+</span>
            </div>
            <div class="modal-body__section__line__icon">
              <span>m</span>
            </div>
            <span>{{ $t('estimation.ordinary_money') }}</span>
          </div>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <span>Ctrl</span>
            </div>
            <div
              class="modal-body__section__line__icon modal-body__section__line__icon--add"
            >
              <span>+</span>
            </div>
            <div class="modal-body__section__line__icon">
              <span>f</span>
            </div>
            <span>{{ $t('estimation.counterfeit_money') }}</span>
          </div>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <span>Ctrl</span>
            </div>
            <div
              class="modal-body__section__line__icon modal-body__section__line__icon--add"
            >
              <span>+</span>
            </div>
            <div class="modal-body__section__line__icon">
              <span>b</span>
            </div>
            <span>{{ $t('estimation.bullion_coin') }}</span>
          </div>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <span>123...</span>
            </div>
            <span>{{ $t('help.make_estimation') }}</span>
          </div>

          <div class="modal-body__section__line">
            <div class="modal-body__section__line__icon">
              <i class="fas fa-level-down-alt rotate-90"></i>
              <span> Enter</span>
            </div>
            <span>{{ $t('help.validate') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>
